import { render, staticRenderFns } from "./GeneralConfiguration.vue?vue&type=template&id=a70bec80&"
import script from "./GeneralConfiguration.vue?vue&type=script&lang=js&"
export * from "./GeneralConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports